import { useState } from 'react';
import s from './UpdateNotice.module.scss';

// ============================================================================
//  홈 중앙 은은한 공지 — [2026-10-23 사용자] 금~월 UI/UX 디자인 수시 갱신 안내.
//   ★하위 클릭 방해 금지(사용자): 래퍼·pill = pointer-events:none(클릭이 아래 요소로 통과),
//     닫기 X만 pointer-events:auto로 클릭 가능. → 화면 중앙에 떠 있어도 뒤 콘텐츠 클릭 정상.
//   닫으면 localStorage로 기억(재방문 시 숨김). 임시 공지라 문구는 여기서 바로 수정/제거.
// ============================================================================
const KEY = 'evs_uiux_notice_dismissed_v1';

export default function UpdateNotice() {
  const [show, setShow] = useState(() => {
    try { return localStorage.getItem(KEY) !== '1'; } catch { return true; }
  });
  if (!show) return null;
  const close = () => {
    setShow(false);
    try { localStorage.setItem(KEY, '1'); } catch { /* 프라이빗 모드 등 무시 */ }
  };
  return (
    <div className={s.wrap} role="status" aria-live="polite">
      <div className={s.pill}>
        <span className={s.dot} aria-hidden />
        <span className={s.txt}>금요일~월요일, <b>UI/UX</b> 디자인을 수시로 개선·갱신하고 있습니다.</span>
        <button className={s.close} onClick={close} aria-label="공지 닫기">×</button>
      </div>
    </div>
  );
}
